export default {
    "type": "object",
    "required": [ 'bpowner', 'bpcompany' ],
    "properties": {
        "bpcompany": {
            "type": "string",
            "default": "",
            "title": "Company",
            "x-cols": "6",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpowner": {
            "type": "string",
            "default": "",
            "title": "Business Owner",
            "x-cols": "4",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpcontactno": {
            "type": "string",
            "default": "",
            "title": "Contact No.",
            "x-cols": "2",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpaddr1": {
            "type": "string",
            "default": "",
            "title": "Address (Line 1)",
            "x-cols": "12",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpaddr2": {
            "type": "string",
            "default": "",
            "title": "Address (Line 2)",
            "x-cols": "12",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpaddr3": {
            "type": "string",
            "default": "",
            "title": "Address (Line 3)",
            "x-cols": "12",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpcity": {
            "type": "string",
            "default": "",
            "title": "City",
            "x-cols": "4",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpstate": {
            "type": "string",
            "default": "",
            "title": "State",
            "x-cols": "4",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bppostcode": {
            "type": "string",
            "default": "",
            "title": "Postcode",
            "x-cols": "4",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
            },
        },
        "bpownerid": {
            "type": "integer",
            "default": "",
            "title": "Owner User Account",
            "x-cols": "4",
            "x-class": "pr-2",
            "x-fromUrl": "/admin/business-partners/all-bpusers",
            "x-itemsProp": "data",
            "x-itemTitle": "name",
            "x-itemKey": "id",
            "x-props": {
                "readonly": false,
            },
        }
    }
}
